export default __webpack_public_path__ + "static/media/collaboration.1419d3a4.png";